const Dashboard = () => import("../layouts/dashboard.vue");
const PaymentForm = () => import("../pages/payment/paymentForm.vue");

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export const financialRoutes = [
  {
    path: "/financeiro",
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: "pagamento",
        component: PaymentForm,
      },
    ],
  },
];
